import { Theme } from "@material-ui/core/styles";
import COLORS from "../../../../../../UI/Theme/colors";

const style: any = (theme: Theme) => ({
	tableContainer: {
		padding: "0px 40px 40px",

	},
	root: {
		width: "100%",
		flexGrow: 1,
		padding: "32px 40px 20px",
	}
	,
	container: {
		height: 92,
		alignItems: "center",
		padding: "32px 40px 24px",
		backgroundColor: "#FFFF",
	},
	gridContainer: {
		justifyContent: "flex-end",
		marginBottom: "15px"
	},
	title: {
		fontSize: 24,
		fontWeight: theme.typography.fontWeightBold,
	},
	toolBoxCountText: {
		fontSize: 18,
		fontWeight: theme.typography.fontWeightBold,
	},
	nojobMessage: {
		color: "#6a737c",
		fontSize: 16,
		fontWeight: 600,
		marginRight: 6,
		textAlign: "center",
		padding: "0px 40px 40px",
		height: 94,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		paddingTop: "65px"
	},
	nojobMessageContainer: {
		paddingLeft: 12,
		paddingRight: 12,
		backgroundColor: "#ffffff",
		height: "120px",
		width: "100%",
	},
	search: {
		position: "relative" as const,
		borderRadius: 2,
		backgroundColor: COLORS.WHITE,
		marginLeft: 8,
		[theme.breakpoints.up("sm")]: {
			marginLeft: theme.spacing(1),
			width: "auto",
		},
	},
	inputInput: {
		paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
		padding: theme.spacing(1, 1, 1, 0),
		// vertical padding + font size from searchIcon
		transition: theme.transitions.create("width"),
		fontSize: 14,
		maxWidth: "100%",
		width: 396,
		height: 38,
		backgroundColor: "rgba(255, 255, 255, 0)",
		fontWeight: "normal" as const,
		borderRadius: 2,
		"box-sizing": "border-box",
		border: "1px solid rgb(208, 213, 218)",
	},
	searchIcon: {
		padding: "0px 13px",
		height: "100%",
		position: "absolute" as const,
		pointerEvents: "none" as const,
		display: "flex",
		alignItems: "center" as const,
		justifyContent: "center" as const,
	},
	
	inputElement: {
		"&:hover": {
			border: "1px solid rgb(134, 142, 150)",
		},
		"&.Mui-focused": {
			border: "1px solid rgb(58, 145, 232)",
		},
		"&.Mui-disabled": {
			border: "1px solid rgb(208, 213, 218)",
		},
	},
	noFoundContainer: {
		padding: "32px 32px 40px",
		width: "100%",
		height: 94,
	},
	noFoundMessage: {
		fontSize: 16,
		fontWeight: theme.typography.fontWeightBold,
		color: COLORS.GRAY,
		marginRight: 6,
	},
	closeButton: {
		width: 16,
		height: 16,
	},
	filterButton: {
		backgroundColor: COLORS.WHITE,
		border: "1px solid rgb(208, 213, 218)",
		height: 38,
		Width: "160px",
		marginLeft: 12,
		color: COLORS.DARK_GRAY,
		fontWeight: theme.typography.fontWeightMedium,
		padding: "7px 12px 8px 12px",
		"&:hover": {
			border: "1px solid #868e96",
			backgroundColor: COLORS.WHITE,
		},
		justifyContent: "flex-start"
	},
});

export default style;